import { Button, Col, Form, Input, InputNumber, FormInstance, Row } from "antd";
import Pix from "../../../../../../Models/Financeiro/Titulo/Pagamento/Pix";

interface IPixFormBasicProps<T> {
    form:FormInstance<T>,
    nameBase:string[],
    namePath:string[],
}
export default function PixFormBasic<T>({
    form,
    nameBase,
    namePath
}:IPixFormBasicProps<T>) {
    // const formContext = Form.useFormInstance<Pix>();
    // const [formulario] = Form.useForm<Pix>();
    // const isForm = ((formContext ?? null) === null);
    // // const formulario = isForm ? newForm : formContext;
    // function onCancelar_Click() {
    //     formulario.resetFields();

    //     onCancelar?.();
    // }
    
    // function onSalvar_Click() {
    //     const pagamento = formulario.getFieldsValue();
    //     if (isForm) {
    //         onChange?.(pagamento);
    //         onCancelar_Click();
    //     }
    //     else {
    //         formulario.validateFields({ validateOnly : false })
    //             .then(e => {
    //                 onChange?.(pagamento);
    
    //                 onCancelar_Click();
    //             }).catch(ex => {
    //             });
    //     }    
    // }

    return <>
        <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item<Pix>
                label={"Identificador"}
                name={[...nameBase, "identificadorProvedor"]}
                rules={[{ required: true, max: 40 }]}
            >
                <Input maxLength={40} placeholder="Identificador" style={{ width: "100%" }} />
            </Form.Item>
        </Col>
        {/* <Col xs={24}>
            <Button 
                type='primary' 
                htmlType={isForm ? "reset" : "button"} 
                danger 
                onClick={onCancelar_Click}
            >
                {isForm ? "Cancelar" : "Limpar"}
            </Button>
            {' '}
            <Button 
                type='primary' 
                htmlType={isForm ? "submit" : "button"}
                onClick={isForm ? undefined : onSalvar_Click}
            >
                {isForm ? "Gravar" : "Incluir"}
            </Button>
        </Col> */}
    </>
}